<mf-page title="Cliente">
  @if (clientDto) {
  <mf-row>
    <mf-row-buttons>
      <mf-button
        text="Administradores"
        (click)="addAdministrator()" />
    </mf-row-buttons>
    <mf-client
      [clientDto]="clientDto"
      (save)="save($event)" />
  </mf-row>
  }
</mf-page>
